import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import EditRecipe from './presenter';
import Types from 'Types';
import { selectActiveRecipe } from 'src/state/recipe/selectors';
import { actions as recipeActions } from 'src/state/recipe';
import { withRouter } from 'react-router-dom';
interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
  recipe: selectActiveRecipe(state)
});

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
  setActiveRecipe: recipeActions.setActiveRecipe,
  fetchRecipe: recipeActions.fetchRecipe.request,
  unSetActiveRecipe: recipeActions.unSetActiveRecipe,
  updateRecipe: recipeActions.updateRecipe.request
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(EditRecipe));